import { type Row, type Table } from "@tanstack/react-table";
import cx from "classnames";
import { type FC } from "react";

import { DataTableIcon, DocumentIcon } from "@moment/icons";
import { MomentButton } from "@moment/ui";

import { BasicDialog, useDialog } from "../../Dialog";
import { getRowGroup, getTableHeaderGroups } from "../CustomTable/TableGroup";
import { type ColumnType } from "../validation/parseColumnType";
import { RowDetailCell } from "./RowDetailCell";

export interface TableCellValueRowDetailProps {
	rowType: Extract<ColumnType, "Multiline text" | "Table">;
	table: Table<unknown>;
	value: any;
	columnId: string;
	row: Row<unknown>;
}
export const TableCellValueRowDetail: FC<TableCellValueRowDetailProps> = ({
	rowType,
	table,
	value,
	columnId,
	row,
}) => {
	const dialogProps = useDialog();
	const [headerGroups] = getTableHeaderGroups(table, "center");
	const rowGroup = Object.fromEntries(
		getRowGroup(row, "center").flatMap((cell) => [[cell.column.id, cell]] as const)
	);
	const content = (
		<div className="flex flex-col gap-8 md:w-[952x]">
			{headerGroups.flatMap((group) =>
				group.headers.map((header) => {
					const cell = rowGroup[header.column.id];
					return (
						<RowDetailCell
							table={table}
							key={header.id}
							header={header}
							cell={cell}
							scrollIntoView={header.column.id === columnId}
						/>
					);
				})
			)}
		</div>
	);

	let Icon = DocumentIcon;
	switch (rowType) {
		case "Multiline text":
			Icon = DocumentIcon;
			break;
		case "Table":
			Icon = DataTableIcon;
			break;
	}

	let valuePopulated = false;
	switch (rowType) {
		case "Multiline text":
			valuePopulated = typeof value === "string" && value.length > 0;
			break;
		case "Table":
			valuePopulated = Array.isArray(value?.dataValue) && value.dataValue.length > 0;
			break;
	}

	return (
		<div className="invisible flex h-full items-center">
			<BasicDialog
				{...dialogProps}
				title="Row details"
				// titleIcon={<Icon icon={Icon} />}
				titleIcon={<></>}
				wide
				content={content}
				confirmText="Close"
				onConfirm={dialogProps.closeDialog}
				onOpenAutoFocus={(e) => e.preventDefault()}
				hideCancel
			>
				<div className="group-hover/datagrid-row:visible">
					<MomentButton
						className={cx("[&>svg]:visible", {
							"[&>svg]:!fill-icon-button-normal-secondary-default": valuePopulated,

							"[&>svg]:!fill-gray-300 hover [&>svg]:hover:!fill-icon-button-normal-secondary-hover [&>svg]:focus:!fill-icon-button-normal-secondary-focus [&>svg]:active:!fill-icon-button-normal-secondary-active [&>svg]:disabled:!fill-icon-button-normal-secondary-disabled":
								!valuePopulated,
						})}
						icon={Icon}
					>
						<div>Open</div>
					</MomentButton>
				</div>
			</BasicDialog>
		</div>
	);
};
